import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const BookmarkIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M13 2H7C5.34315 2 4 3.34315 4 5L4.00002 16.7268C4.00002 17.5969 5.03434 18.0519 5.67574 17.4639L9.32428 14.1194C9.7066 13.769 10.2934 13.769 10.6757 14.1194L14.3243 17.4639C14.9657 18.0519 16 17.5969 16 16.7268L16 5C16 3.34314 14.6568 2 13 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};
